import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import Assessment from '@material-ui/icons/Assessment'
import TextField from "@material-ui/core/TextField";
import {Objects} from "../index";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import GradeComponent from "../Objects/GradeComponent";
import Collections from "./index";

export default class KpiScores extends Framework.Components.Collection {
	constructor(props) {

		let model = new API.BuildClass(Types.Kpi_Metrics._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_SCORES'
		this.state.limit = 50;
		//this.state.filterDate = moment(Date.now()).format();
		this.state.filterDate = moment().format('YYYY-MM-DD');
		this.state.showDate = false;
	}

	fetchData = async () => {
		this.state.limit = 50;
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.filterDate = moment(this.state.filterDate).format('YYYY-MM-DD');
		this.state.filter.week_view = this.props.week_view;
		this.model.filter = this.state.filter;
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual();
		}, 100);
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	handleDateChange = async (name, date) => {
		this.state.filterDate = moment(date).format();
		await this.setState({filterDate: moment(date).format('YYYY-MM-DD')});
		this.handleToggleModal('showDate');
		await this.fetchData();
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns = [
			{
				Header: "User",
				id: 'user',
				/** @param {Kpi_Metrics_Object} obj */
				accessor: obj => obj.user,
			},
			{
				Header: `Calls for ${this.props.week_view ? 'Week' : 'Day'}`,
				id: 'score_day',
				/** @param {Kpi_Metrics_Object} obj */
				accessor: obj => obj.score_day,
			},
			{
				Header: `Book % for ${this.props.week_view ? 'Week' : 'Day'}`,
				id: 'book_percent_day',
				/** @param {Kpi_Metrics_Object} obj */
				accessor: obj => obj.book_percent_day > 0 ? obj.book_percent_day + '%' : "N/A",
			},
			{
				Header: `${this.props.week_view ? 'Week' : 'Day'} Grade`,
				id: "letter_score_day",
				className: "button-cell",
				filterable: false,
				sortable: true,
				width: 200,
				accessor: obj => obj.letter_score_day,
				Cell: props => {
					let score = Math.round(props.original.letter_score_day * 10) / 10;
					if (score.toString().includes('.0')) {
						score = score.toString().split('.')[0]
					}
					return (
						<>
							{props.row._original.score_day > 0 ?
								<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
									{score}%
									&nbsp;
									<GradeComponent score={props.original.letter_score_day}/>
									&nbsp;
									<Button color="blue-hoki" size={"sm"} block={false} onClick={() => {
										this.setState({
											user: props.original.dispatcher, hourly_breakdown_modal: true,
											name: props.original.user, day_score_display: score, day_score: props.original.letter_score_day
										})
									}}>
										<Assessment fontSize={'small'}/></Button>
								</div> :
								<b>
									N/A
								</b>}
						</>
					);
				}
			},
		]
		const regexp = new RegExp(/\D/, 'g');
		return (
			<div className={'container-fluid'}>

				<Card>
					<CardContent>
						<div className="table-bar">
							<Modal
								isOpen={this.state.showDate}
								toggle={() => this.handleToggleModal('showDate')}
								size={"sm"}
								backdrop={true}
								style={{display: "none"}}
							>
								<ModalBody>
									<Framework.Elements.Date
										label={"Custom Date"}
										value={this.state.filterDate}
										update={this.handleDateChange}
										open={this.state.showDate}
										clearable={false}
										cancelLabel={''}
									/>
								</ModalBody>
							</Modal>
							<div className={"row rbc-toolbar"}>
								<div>
									<IconButton onClick={async () => {
										const today = moment(Date.now()).format('YYYY-MM-DD');
										this.setState({
											filterDate: moment(this.state.filterDate).subtract(1, 'day').format(),
											dateRangeFormatted: null,
											start_date: today,
											end_date: today
										}, async () => {
											await this.fetchData();
										})
									}}><LeftArrowIcon/></IconButton>
									<button className="rbc-today" type="button" onClick={async () => {
										const today = moment(Date.now()).format('YYYY-MM-DD');
										this.setState({
											filterDate: moment(Date.now()).format(),
											dateRangeFormatted: null,
											start_date: today,
											end_date: today
										}, async () => {
											await this.fetchData();
										})
									}}>Today
									</button>
									<IconButton onClick={async () => {
										const today = moment(Date.now()).format('YYYY-MM-DD');
										this.setState({
											filterDate: moment(this.state.filterDate).add(1, 'day').format(),
											dateRangeFormatted: null,
											start_date: today,
											end_date: today
										}, async () => {
											await this.fetchData();
										})
									}}><RightArrowIcon/></IconButton>
								</div>
								<div className={"rbc-toolbar-label"}>
									<label onClick={() => {
										this.handleToggleModal('showDate')
									}}>
										{this.state.dateRangeFormatted ? this.state.dateRangeFormatted : moment(this.state.filterDate).format('dddd MMM D')}
									</label>
								</div>
								<div className="d-flex">
									{this.renderHeaderRight("KPI Scores Dispatch",columns)}
								</div>
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							onSortedChange={this.onSortedChange}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={data.length}
							className="-striped -highlight"
							onPageSizeChange={this.onPageSizeChange}
							pageSize={data.length}
						/>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>
				</Card>
				<Framework.Elements.UniversalModal
					name={"Hourly Breakdown"}
					object={Collections.DispatcherScores}
					history={this.props.history}
					toggle={this.state.hourly_breakdown_modal}
					reportClose={() => this.handleToggleModal('hourly_breakdown_modal')}
					objectProps={{
						user: this.state.user,
						filterDate: this.state.filterDate,
						name: this.state.name,
						day_score_display: this.state.day_score_display,
						day_score: this.state.day_score,
						hideDates: true
					}}
					hideGoTo={true}
				/>
			</div>
		)
	}
}
